export default (object) => Object.keys(object).map((key) => ({ name: key, ...object[key] }));
